<template>
    <div class="buyers-order-row" :style="gridStyle">
        <div>
            <slot name="left-icon"></slot>
        </div>

        <div class="row-info-container">
            <slot name="info"></slot>
        </div>

        <div class="bo-bucket-sign">
            <slot name="right-icon"></slot>
        </div>

        <div class="amt first-amt">
            <slot name="column-1"></slot>
        </div>

        <div v-if="!hideExtraColumns" class="amt">
            <slot name="column-2"></slot>
        </div>

        <div v-if="!hideExtraColumns" class="amt">
            <slot name="column-3"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { $gridType } from '@core/plugins/static';

interface IBuyersOrderRowProps {
    hideExtraColumns?: boolean;
}

const { hideExtraColumns = false } = defineProps<IBuyersOrderRowProps>();

const $grid = inject<$gridType>('$grid');

const gridStyle = computed(() => {
    const templateColumns = hideExtraColumns ? `25px-1-30px-125px` : `25px-1-30px-125px-125px-125px`;

    return $grid(templateColumns, '0px 5px');
});
</script>

<style scoped>
.buyers-order-row {
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    box-sizing: border-box;
    place-items: center;
}

.row-info-container {
    display: flex;
    align-items: center;
    width: 100%;
}

.group-children-container>.buyers-order-row>.first-amt {
    width: calc(100% - 5px);
    padding-left: 5px;
}

.amt {
    display: block;
    width: 100%;
    display: flex;
}
</style>
